import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Formik } from 'formik';
import { boolean, object, string } from 'yup';

import Checkbox from 'components/Checkbox';
import Icon from 'components/Icon';

import styles from './styles.module.scss';

const SubscribeForm = ({ id, theme, onSubmit }) => {
	const schema = useMemo(
		() =>
			object({
				email: string()
					.email(
						'Адрес электронной почты введен в неправильном формате. Пример, example@domain.ru'
					)
					.required('Пожалуйста, введите свой e-mail'),
				termsAccepted: boolean().oneOf(
					[true],
					'Пожалуйста, подтвердите согласие с условиями Правил'
				)
			}),
		[]
	);

	const subscribeFormCx = cx(styles.form, styles[`theme_${theme}`]);

	return (
		<Formik
			initialValues={{
				email: '',
				termsAccepted: true
			}}
			onSubmit={onSubmit}
			validationSchema={schema}
		>
			{({
				handleSubmit,
				handleBlur,
				handleChange,
				values,
				touched,
				errors,
				setFieldValue
			}) => (
				<form
					id={id}
					key="subscribeForm"
					onSubmit={handleSubmit}
					className={subscribeFormCx}
				>
					<div className={cx(styles.block, styles.primary)}>
						<input
							className={styles.control}
							name="email"
							type="email"
							placeholder="E-mail"
							value={values.email}
							onChange={handleChange}
							onBlur={handleBlur}
							tabIndex={0}
							aria-label="Поле для подписки на рассылку, ввести email"
						/>
						<button
							type="submit"
							className={styles.btn}
							title="Отправить"
							tabIndex={0}
							aria-label="Отправить email"
						>
							<Icon icon="chevronRight" className={styles.icon} />
						</button>
					</div>
					<div className={cx(styles.block, styles.secondary)}>
						<Checkbox
							text={[
								'Я согласен(-на) с условиями ',
								<a
									key="link"
									href="https://www.culture.ru/terms-of-use"
									target="_blank"
									rel="noopener"
								>
									Правил пользования порталом «Культура.РФ»
								</a>
							]}
							id={`${id}-terms-accepted`}
							name="termsAccepted"
							checked={values.termsAccepted}
							onChange={handleChange}
							onBlur={handleBlur}
							tabIndex={0}
							arialLabel="Согласиться с условиями правила пользования порталом «Культура.РФ»"
							onKeyUp={(event) => {
								const keyCode = event.keyCode || event.which;

								if (keyCode === 13) {
									setFieldValue('termsAccepted', !values.termsAccepted);
								}
							}}
						/>
						{((touched.email && errors.email) || errors.termsAccepted) && (
							<div className={styles.error}>
								{errors.termsAccepted || errors.email}
							</div>
						)}
					</div>
				</form>
			)}
		</Formik>
	);
};

SubscribeForm.propTypes = {
	id: PropTypes.string.isRequired,
	onSubmit: PropTypes.func.isRequired,
	theme: PropTypes.oneOf(['air'])
};

export default SubscribeForm;
